export function isAlsoSearched() {
  return localStorage.getItem("alsoSearched") === "true";
}

export function setAlsoSearched(value: boolean) {
  if (value) {
    localStorage.setItem("alsoSearched", "true");
  } else {
    localStorage.removeItem("alsoSearched");
  }
}
